/* eslint-disable import/prefer-default-export */
import { useSelector } from 'react-redux';
import { apiService } from '../../utils/api';

export const usePhaseService = () => {
  const { contract } = useSelector((state) => state.contract);
  const contractId = contract?.id ?? null;

  const getPhases = () => apiService.get(`/api/v1/phase/left-panel/?contract=${contractId}`);

  const getPhase = (id) => apiService.get(`/api/v1/phase/${id}/`);

  const getPhaseTypes = () =>
    apiService.get(`/api/v1/phase-type/dropdown/?contract=${contractId}&pagination=false`);
  const getModels = () =>
    apiService.get(`/api/v1/model/dropdown/?contract=${contractId}&pagination=false`);

  const addPhase = (values) =>
    apiService.post('/api/v1/phase/', {
      ...values,
      contract: contractId,
    });

  const updateModel = (id, values) =>
    apiService.patch(`/api/v1/phase/${id}/?contract=${contractId}`, values);

  return {
    getPhases,
    getPhase,
    getPhaseTypes,
    getModels,
    addPhase,
    updateModel,
  };
};
